import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SearchResult = () => {
    return (
        <div id="result-search-wrapper"
             className="result-search-wrapper-header xp-4 position-absolute">
            <div className="product-result">
                <h2 className="xmb-2">محصولات</h2>
                <ul className="list-unstyled" id="product-ul-search">
                </ul>
                <li className="list-unstyled show-all-products xmt-2 xmb-4 xmr-2">
                    <IconName name="products" className="icon"/>
                    <a href="#">مشاهده همه محصولات</a>
                </li>
            </div>
            <div className="blog-result">
                <h2 className="xmb-2 xmt-2">وب لاگ</h2>
                <ul className="list-unstyled" id="blog-ul-search">
                </ul>
                <li className="list-unstyled show-all-blogs xmt-2 xmb-4 xmr-2">
                    <IconName name="blog" className="icon"/>
                    <a  id="search-all-blog" href="#">مشاهده‌ی همه‌ی محتواها</a>
                </li>
            </div>
        </div>
    );
};

export default SearchResult;
